// hotel.js
const hotel = {
    edit_common_commodity: '编辑常用商品',
    add_common_commodity: '新增常用商品',
    tax_classification_code: '税收分类编码',
    select_tax_classification_code: '请选择税收分类编码',
    click_search: '点击搜索',
    specification_model: '规格型号',
    enter_tax_specification_model: '请输入税收规格型号',
    unit_price: '单价',
    enter_unit_price: '请输入单价',
    tax_rate: '税率',
    select_tax_rate: '请选择税率',
    tax_classification_name: '税收分类名称',
    enter_tax_classification_name: '请输入税收分类名称',
    product_name: '商品名称',
    enter_product_name: '请输入商品名称',
    metering_unit: '计量单位',
    enter_metering_unit: '请输入计量单位',
    ticket_parameters_configuration: '票通参数配置',
    child_extension_number: '分机号',
    is_open_full_electric_ticket: '是否开启全电票',
    tips: '注意：请确定是否已经开通全电发票，如未开通请选择否。',
    invoice_parameters_configuration: '发票参数配置-{value}',
    fill_parameters: '填写参数',
    invoice_type: '开票方式名称',
    enterprise_basic_info: '企业基本信息',
    enterprise_name: '企业名称',
    enter_enterprise_name: '请输入企业名称',
    taxpayer_identification_number: '纳税人识别号',
    tip_api_invoice: '注意：如需接口开票此项必填',
    enterprise_business_address: '企业经营地址',
    enterprise_phone: '企业电话',
    enterprise_bank: '企业开户行',
    enterprise_bank_account: '企业开户行账号',
    taxpayer_category: '纳税人类别',
    small_scale_taxpayer: '小规模纳税人',
    general_taxpayer: '一般纳税人',
    payee: '收款人',
    reviewer: '复核人',
    invoicer: '开票人',
    invoice_collection_rules: '发票收集规则',
    tip_invoice_collection: '注意：提交发票数据会根据配置规则验证是否合格',
    restrict_invoice_title: '是否限制发票抬头必须和用户单位一致',
    allow_vague_match: '是否允许发票抬头与用户单位模糊匹配',
    tip_vague_match: '允许后发票抬头包含用户单位或者用户单位包含发票抬头都可以验证通过',
    invoice_title_blacklist: '发票抬头黑名单',
    enter_invoice_title_blacklist: '请输入发票抬头黑名单',
    tip_blacklist_keywords: '多个关键词用|隔开，例如：个人|公司|有限',
    invoice_title_whitelist: '发票抬头白名单',
    enter_invoice_title_whitelist: '请输入发票抬头白名单',
    tip_whitelist_keywords: '多个关键词用|隔开，如果是多个词组成词直接用+串联起来；例如：医院+公司|大学+公司',
    tax_number_length_rule: '税号位数限制规则',
    digits: '{num}位',
    invoice_info_collection_default: '发票信息收集默认配置',
    tip_invoice_info_default: '注意：此项为默认配置，项目审核选择此渠道会默认把配置同步到项目中',
    open_invoice_info_collection: '是否开通发票信息收集',
    optional_invoice_types: '可选发票类型',
    vat_electronic_invoice: '增值税普通电子发票',
    vat_special_invoice: '增值税专用发票',
    vat_paper_invoice: '增值税普通纸质发票',
    fixed_amount_invoice: '定额发票',
    fiscal_receipt: '财政票据',
    required_invoice_info: '是否必填发票信息',
    allow_personal_invoice: '是否允许开个人发票',
    collect_invoice_mailing_info: '是否收集发票邮寄信息',
    hotel_receipt_download: '酒店费收据下载',
    hotel_receipt_template: '酒店费收据模板',
    tip_receipt_template: '建议文件小于3M，支持doc、docx格式',
    download_english_receipt_template: '英文收据模板下载',
    tag_info: '标签信息',
    electronic_invoice_default: '电子发票默认配置',
    tip_electronic_invoice_default: '注意：此项为默认配置，项目审核选择此渠道会默认把配置同步到项目中',
    enable_electronic_invoice_management: '是否启用电子发票管理',
    disable_electronic_invoice: '否，不支持开具电子发票',
    enable_electronic_invoice: '是，支持在线开具电子发票',
    hotel_personal_offline_invoice: '酒店个人【线下支付】开票',
    not_allow_electronic_invoice: '不允许申请电子发票',
    user_apply_admin_issue: '用户可申请【管理员开具】电子发票',
    auto_issue_after_payment: '用户缴费后自动开发票（只支持电子发票）',
    hotel_personal_online_invoice: '酒店个人【线上支付】开票',
    hotel_team_offline_invoice: '酒店团队【线下支付】开票',
    hotel_team_online_invoice: '酒店团队【线上支付】开票',
    invoice_remark_display: '发票备注显示形式',
    custom_remark: '自定义',
    fixed_remark: '固定显示',
    invoice_remark_info: '发票备注信息',
    enter_invoice_remark_info: '请输入发票备注信息',
    tip_invoice_remark: '票面备注信息，如果不填写，票面展示为空，如果填入则根据填入信息填入票面信息！',
    download_sample: '下载样例',
    please_fill_in_complete_invoice_information: '请您填写完整的发票信息',
    service_item_configuration: '服务项目配置-{name}',
    tax_simple_name: '税收分类简称',
    goods_no: '企业商品编号',
    please_enter_content: '请输入需要查询的内容',
    code: '编码',
    concat_code: '合并编码',
    goods_activity_name: '货物和劳动名称',
    add_tax_rate: '增值税税率',
    add_tax_management: '增值税特殊管理',
    add_tax_by: '增值税政策依据',
    summary: '汇总',
    // 支付配置相关字段
    is_show_label: '是否在收银台显示',
    is_show_desc: '如果选择隐藏该支付方式只会在会议后台显示，代表前台支付的时候不会显示该支付方式',
    pay_alias_label: '别名',
    pay_service_charge_label: '手续费比率',
    pay_service_charge_desc: '手续费率填写则表示需要代表承担手续费，不填写默认为0则表示不需要代表承担（半角小数,如3.3%换算为0.033）',
    is_refund_label: '是否开启退款',
    partnerid_label: 'partnerid(合作者 id)',
    schoolcode_label: 'schoolcode',
    accountid_label: 'accountid',
    des_label: '3DES密钥',
    private_key_label: '商户私钥',
    public_key_label: '北京大学收银台公钥',
    pay_order_label: '排序号',
    pay_order_rule: '前台显示排序号',
    pay_desc_label: '支付说明',
    is_weixin_label: '是否支持微信支付',
    is_alipay_label: '是否支持支付宝支付',
    is_wechat_public_label: '是否支持微信公众号支付',
    wechat_appid_label: 'APPID',
    wechat_appsecret_label: 'APPSecret',
    private_key_pfx_label: '私钥证书文件',
    private_key_pfx_extra: '只能上传.pfx格式的文件，此私钥为北京CA颁发给商户的商户RSA私钥证书',
    pfxpwd_label: '私钥密码',
    company_no: '商户号',
    select_pfx: '请选择.pfx格式的文件',
    merchant_id_label: 'Merchant Id',
    profile_id_label: 'Profile ID',
    access_key_label: '访问密钥',
    secret_label: '密钥',
    api_key_id_label: 'apiKeyID',
    secret_key_label: '共享密钥',
    async_return_url_label: '异步推送地址',
    view_example: '查看示例',
    see_config_instructions: '账户后台支付配置->Secure Acceptance 设置->新建 Profile后->Profile 列表更多列->查看Profile->安全->查看秘钥',
    see_secret_key_instructions: '账户后台支付配置->秘钥管理->生成秘钥->勾选REST - 共享私钥->生成秘钥',
    gateway_public_key_label: '工行网关公钥',
    corp_id_label: '企业编号',
    aes_key_label: 'AESKEY',
    sby_public_key_label: '赛博云网关公钥',
    mer_id_label: '商户线下档案编号/商户编号',
    store_code_label: 'e生活档案编号/收单协议号',
    is_new_version_label: '是否是新版接口',
    // 工行聚合支付配置相关字段
    agree_code_label: '合作方协议编号',
    pay_type_label: '支付方式',
    pay_type_desc: '请跟银行人员确认支付方式，接口不一样',
    pay_type_guarantee: '保证支付',
    pay_type_direct: '直接支付',
    mall_code_label: '收方商户号',
    mall_name_label: '商户名称',
    payee_company_name_label: '收款人户名',
    payee_accno_label: '收款人账号',
    params_set: '参数配置-{name}',
    // 建设银行支付配置相关字段
    bussiness_code_label: '商户代码',
    fenhang_code_label: '分行代码',
    bussiness_gui_code_label: '商户柜台号',
    public_key_label: '公钥',
    // 线下支付配置相关字段
    is_voucher_label: '是否需要上传汇款凭证',
    is_voucher_need: '需要',
    is_voucher_not_need: '不需要',
    is_voucher_must_label: '汇款凭证是否必须上传',
    // 支付配置列表相关字段
    online_payment: '线上支付',
    offline_payment: '线下支付',
    payment_method_name: '支付方式名称',
    application_description: '应用描述',
    status: '状态',
    fill_parameters: '填写参数',
    // 支付时间配置相关字段
    edit_payment_time: '编辑支付时间',
    start_time_label: '开始时间',
    end_time_label: '结束时间',
    // PayPal 支付配置相关字段
    client_id_label: 'Client ID',
    secret: 'Secret',
    // 清华大学支付配置相关字段
    cooper_id_label: '合作方编号',
    key_label: 'Key',
    waibi_pay_num_label: '支付项目编号(外币)',
    zhifubao_pay_num_label: '支付项目编号(支付宝)',
    weixin_pay_num_label: '支付项目编号(微信)',
    // Stripe 支付配置相关字段
    public_key_pk_label: '公钥PK',
    private_key_sk_label: '密钥SK',
    async_push_address_label: '异步推送地址',
    each_merchant_customized: '每个商户需单独定制',
    // 首信易支付配置相关字段
    sxy_merchant_number_label: '首信商户号',
    encryption_method_label: '加密方式',
    sxy_payment_key_label: '首信支付密钥',
    asynchronous_return_address_label: '异步返回地址',
    sxy_async_return_tip: '请在首信易支付管理后台将异步返回地址填入"客户服务"-"商户信息维护"-"订单后台接收地址"中，请通知首信易客服人员将美迪康服务器主动查询订单结果的服务器IP加入白名单',
    server_ip_label: '服务器IP：',
    server_ip_value: '255.255.255.255',
    async_push_type_label: '并将异步推送结果推送方式设为：',
    async_push_type_value: '单笔推送',
    push_encoding_label: '推送编码为：',
    push_encoding_value: 'UTF-8',
    special_attention_label: '特别注意',
    attention: '注意',
    async_return_address_warning: '请仔细检查异步返回地址,确保异步返回地址填写正确！！！！！！！！',
    apply_authorization_letter: '申请授权函',
    // 通联支付配置相关字段
    alliance_public_key_label: '通联公钥',
    // 微信支付配置相关字段
    wechat_public_account_id_label: '公众账号ID',
    wechat_merchant_api_key_label: '商户平台Api密钥',
    wechat_mp_verify_file_label: 'MP_verify_*.txt文件',
    wechat_help_document_label: '帮助文档',
    wechat_config_document_link_text: '《微信支付配置说明》',
    login: '登录',
    wechat_platform: '微信公众平台',
    progress_1: '微信支付"-"商户号管理"-"已关联商户号"-"商户号"',
    progress_2: '"开发"-"基本配置"-"公众号开发信息"-"开发者ID(AppID)"',
    progress_3: '"开发"-"基本配置"-"公众号开发信息"-"开发者密码(AppSecret)"',
    progress_4: '"账户中心"-"API安全"-"API秘钥"中查找设置',
    // 西安银行支付配置相关字段
    merchant_number_label: '商户编号',
    channel_number_label: '渠道号',
    private_key_certificate_file_label: '私钥证书文件',
    private_key_certificate_extra: '只能上传.pfx格式的文件，且文件大小不能大于500KB',
    password_label: '密码',
    upload_credential_button_text: '上传凭证',
    view_label: '查看',
    pay_order_rule_hint: '前台显示排序号',
    // 首信易支付配置相关字段
    terminal_number_label: '终端号',
    private_key_password_label: '私钥密码',
    wechat_payment_support_label: '是否支持微信支付',
    alipay_support_label: '是否支持支付宝支付',
    wechat_public_payment_support_label: '是否支持微信公众号支付',
    sxy_backend_upload_process_link_text: '首信易证书商户后台上传流程',
    sxy_certificate_download_process_link_text: '首信易证书下载流程',
    apply_authorization_letter_label: '申请授权函',
    // 校付通支付配置相关字段
    school_payment_merchant_number_label: '校付通商户号',
    merchant_private_key_label: '商户私钥',
    school_payment_public_key_label: '校付通公钥',
    private_key_version_label: '厂商私钥版本',
    // 新增银支付通配置相关字段
    sysid_label: 'sysId(业务系统的id号)',
    itemid_label: 'itemId(项目分类id)',
    system_certificate_label: '系统证书',
    // 易宝支付配置相关字段
    interface_type_label: '接口类型',
    instant_payment_interface_text: '即时到账接口',
    alipay_mobile_website_payment_tips: '注：如需在微网站使用，请开通支付宝手机网站支付接口',
    initiator_merchant_number_label: '*发起方商户编号',
    merchant_number_label: '*商户编号',
    app_key_label: '*appKey',
    merchant_application_private_key_label: '*商户应用私钥',
    // 银联云闪付配置相关字段
    unionpay_appid_label: '银联AppId',
    unionpay_appkey_label: '银联appKey',
    source_code_label: '来源编码',
    unionpay_merchant_number_scan_label: '银联商户号(扫码支付)',
    terminal_number_scan_label: '终端号(扫码支付)',
    attachment_label: '附件',
    medical_payment_application_form: '医师支付申请表',
    project_number_label: '项目编号',
    meeting_id_label: '会议ID',
    belonging_organization_label: '所属机构',
    partner_id_label: '*合作身份者ID',
    alipay_public_key_label: '支付宝公钥',
    this_public_key_is: '此公钥为',
    merchant_application_private_key_label: '*商户应用私钥',
    get_merchant_application_private_key: '商户应用私钥获取方式',
    business_help_center: '商家帮助中心',
    error_code_illegal_partner_exterface: '错误代码 ILLEGAL_PARTNER_EXTERFACE',
    alipay_configuration_manual: '《支付宝配置说明》',
    authorization_letter: '授权函',
    common_problems: '常见问题',
    please_visit: '请在',
    search_error_code: '搜索错误代码',
    agricultural_bank_root_certificate_file: '农行根证书文件',
    file_suffix_truststore: '文件后缀为.truststore',
    merchant_certificate_directory_name: '商户证书储存目录档名',
    file_suffix_pfx: '文件后缀为.pfx',
    merchant_private_key_encryption_password: '商户私钥加密密码',
    business_number_label: '业务编号',
    password_label: '密码',
    only_pem: '只能上传.pem格式的文件，且文件大小不能大于500KB',
    basic_info: '基本信息',
    chinese: '中文',
    english: '英文',
    hotel_name_cn: '酒店中文名称',
    hotel_address_cn: '酒店中文地址',
    hotel_distance_cn: '距离会场距离(中文)',
    hotel_introduce_cn: '酒店中文介绍',
    hotel_name_en: '酒店英文名称',
    hotel_address_en: '酒店英文地址',
    hotel_distance_en: '距离会场距离(英文)',
    hotel_introduce_en: '酒店英文介绍',
    basic_settings: '基本设置',
    is_open_booking: '是否开放预定',
    hotel_open_object: '酒店开放对象',
    domestic_guests: '中宾',
    foreign_guests: '外宾',
    both_domestic_and_foreign_guests: '中外宾',
    only_for_vip: '是否只针对VIP开放',
    hotel_star: '酒店星级',
    unknown: '未知',
    three_star_approximate: '准三星',
    three_star: '三星',
    four_star_approximate: '准四星',
    four_star: '四星',
    five_star_approximate: '准五星',
    five_star: '五星',
    business: '商务',
    checkin_start_date: '入住起始日期',
    checkin_end_date: '入住结束日期',
    checkout_start_date: '退房起始日期',
    checkout_end_date: '退房结束日期',
    hotel_image: '酒店图片',
    image_size_hint: '尺寸为500x330,宽高比例为3:2',
    hotel_facilities: '酒店设施',
    free_wifi: '免费无线',
    free_cable: '免费有线',
    parking_lot: '停车场',
    restaurant: '餐厅',
    swimming_pool: '游泳池',
    gym: '健身房',
    breakfast_included: '含早餐',
    conference_shuttle_bus: '会议班车',
    new_hotel: '新增酒店',
    edit_hotel: '编辑酒店',
    passenger_info: '住客信息',
    name: '姓名',
    sex: '性别',
    mobile: '手机号',
    hotel_name: '酒店名称',
    room_type: '房型名称',
    check_in_date: '入住日期',
    check_out_date: '离店日期',
    checkin_period: '入住起止时间',
    checkout_period: '退房起止时间',
    bed_room_bool: '整间床位预订',
    room_type_cn: '房型中文名称',
    min_day: '最少预订天数',
    sort_num: '房型排序',
    room_type_en: '房型英文名称',
    bed_nums: '每间房内床位数',
    deposit_mode: '预定金模式',
    enable_deposit_mode: '开启预定金模式',
    price_set_type: '价格数量配置方式',
    batch_config: '批量配置',
    individual_config: '独立配置',
    price_quantity_setting: '数量价格设置',
    date: '日期',
    room_num: '房间数量',
    cn_price: '中宾价格',
    en_price: '外宾价格',
    room_price: '整间单价',
    bed_price: '床位单价',
    room_introduce: '房型介绍',
    submit_now: '立即提交',
    both: '整间和床位都可以预订',
    only_room: '只能预订整间',
    only_bed: '只能预订床位',
    select_currency_cn: '请选择中宾币种',
    chinese_yuan: '人民币',
    us_dollar: '美元',
    euro: '欧元',
    hk_dollar: '香港元',
    mo_dollar: '澳门元',
    select_currency_en: '请选择外宾币种',
    remaining_bed_count: '床位剩余数量',
    remaining_room_count: '整间剩余数量',
    enter_room_price_cn: '请输入中宾整间价格',
    enter_bed_price_cn: '请输入中宾床位价格',
    enter_room_price_en: '请输入外宾整间单价',
    enter_bed_price_en: '请输入外宾床位单价',
    new_room_type: '新增房型',
    edit_room_type: '编辑房型',
    tab_chinese_config: '中宾配置',
    tab_foreign_config: '外宾配置',
    tab_batch_operation: '批量操作',
    is_open_hotel_booking: '是否开启酒店预订',
    hotel_booking_restrictions: '酒店预订限制条件',
    hotel_booking_deadline: '酒店预订截至日期',
    per_person_booking_limit: '每人单次可预订数量',
    can_book_multiple_times: '是否可以多次下单',
    show_room_remaining_quantity: '是否显示房间剩余数量',
    room_deduction_mode: '房间数量扣除方式',
    collect_other_needs: '是否收集其他需求',
    booking_page_description: '预订页面说明文字',
    unrestricted: '不限制',
    need_ticket_selected: '需要选择门票',
    need_ticket_and_paid: '需要选择门票并支付成功',
    can_book_multiple_times_yes: '可以多次下单',
    can_book_multiple_times_no: '只可以支付一笔订单',
    show_room_surplus_no: '不显示',
    show_room_surplus_yes: '显示',
    deduct_on_booking: '预订后扣除',
    deduct_after_payment: '预订并成功支付后扣除',
    collect_other_needs_no: '不收集',
    collect_other_needs_yes: '收集',
    room_type_statistics: '房间类型统计',
    check_in_out_statistics: '入住/离店日期统计',
    room_shape: '房型',
    every_room_bed_count: '每间房床位数',
    check_in_num: '入住人数',
    check_out_num: '退房人数',
    invoice_cn: '中宾发票配置',
    invoice_en: '外宾发票配置',
    invoice_params: '发票参数配置',
    service: '服务项目',
    invoice_api: '发票接口配置',
    channel_category_name: '渠道分类名称',
    book_type: '预订类型',
    one_room: '整间',
    onr_bed: '床位',
    order_info: '预订信息',
    pay_params: '支付参数配置',
    pay_time: '支付时间配置',
    is_show_refund_button: '是否显示退款按钮',
    collect_refund_account_info: '是否收集退款账号信息',
    booked: '已预订',
    remaining: '剩余',
    // 酒店类型页面相关
    add_hotel: '添加酒店',
    vip_tag: 'VIP',
    open_status: '开放中',
    closed_status: '已关闭',
    open_object: '开放对象',
    domestic_guests: '中宾',
    foreign_guests: '外宾',
    both_domestic_and_foreign_guests: '中宾+外宾',
    checkin_period: '入住起止日期',
    checkout_period: '退房起止日期',
    add_room_type: '添加房型',
    deposit_mode_label: '预定金',
    confirm_delete_hotel: '确定删除该酒店吗？',
    confirm_delete_room: '确定删除该房型吗？',
    booking_content: '预定内容',
    certificate: '证书',
    refund_deadline: '退款截止时间',
    // Select day modal
    surplus: '余',
    check_in: '入住',
    check_out: '离店',
    select_date: '选择日期',
    check_in_out_date_required: '请选择起止日期',
    select_check_out_date_required: '请选择离店日期',
    please_select_check_in_out_date: '请选择入住和离店日期',
    no_room_available_on_this_date: '该日期没有可用房间',
    min_day_required: '最小入住天数为 {minDay} 天，无法选择该日期作为离店日期',
    select_date_not_available: '所选日期范围内存在不可预订的日期，请重新选择',
    checkin_date_not_available: '入住日期必须在 {checkin_start} 和 {checkin_end} 之间',
    checkout_date_not_available: '退房日期必须在 {checkout_start} 和 {checkout_end} 之间',
    hotel_room_select: '酒店房型选择',
    price_start: '起',
    distance_from_the_venue: '距会场',
    select_room: '选择房型',
    select_room_required: '请选择房型',
    bed_name: '床位',
    room_name: '整间',
    description: '简介',
    check_in_out_date_name: '起止日期',
    check_in_out_date_required: '请选择起止日期',
    check_in_date: '入住时间',
    check_out_date: '退房时间',
    book_num: '预定数量',
    select_book_num: '请选择预定数量',
    bed_tag: '位',
    room_tag: '间',
    room_surplus: '剩余：',
    hotel_config: '酒店设施：',
    book_text: '立即预定',
    room_treatment: '房型所需待遇',
    please_select_room_treatment: '请选择房型所需待遇'
};

export default hotel;
